import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { EstimatedUnbillFigureProvider } from "presentation/store/EstimatedUnbillFigure/EstimatedUnbillFigureProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import EstimatedUnbillFigureMaintenance from "presentation/view/section/EstimatedUnbillFigure/EstimatedUnbillFigureMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const EstimateUnbillFigureContMain = () => {
    return <ANAInfoWrapper permission={Permission.ESTIMATED_UNBILL_FIGURE_MAINTENANCE}>
        <MessageBarWrapper>
            <EstimatedUnbillFigureProvider>
                <GridStyles />
                <EstimatedUnbillFigureMaintenance />
            </EstimatedUnbillFigureProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default EstimateUnbillFigureContMain;